const PAGINATION_KEY = 'sessionPaginationInfo'

export const getSessionPaginationInfo = (): any | null => {
  if (typeof window !== 'undefined') {
    // Access sessionStorage only if window is defined
    const dataJson = window.sessionStorage.getItem(PAGINATION_KEY)

    return dataJson ? JSON.parse(dataJson) : null
  }

  // Return null or handle the case where sessionStorage is not available
  return null
}

export const setSessionPaginationInfo = (
  sessionPage: number,
  sessionPath: string,
  sessionScrollPosition: number
): void => {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem(
      PAGINATION_KEY,
      JSON.stringify({
        sessionPage,
        sessionPath,
        sessionScrollPosition,
      })
    )
  }
}
